import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserPermissionService } from 'shared/services/user-permissions/user-permission.service';
import { ActionPermissionType } from 'common/common/constants/permission-type-enum';
import { BrowserSupportService } from 'shared/services/browser-support/browser-support.service';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { ServiceEvaluatorService } from 'shared/services/service-evaluator/service-evaluator.service';
import { Settings } from 'common/settings/settings.interface';
import { BcFeatures } from 'common/common/constants/feature-enums';
import { DiscussionsService } from 'shared/components/discussions/discussions.service';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { BcSettingsService } from 'common/settings/settings.service';
import { BcConfigService } from 'common/config/provider';
import { CommonAuthService } from 'common/auth/common-auth.service';
import { UserPermission as GenesysUserPermission } from 'common/store/genesys-cloud/users/models/user-permission.enum';

@Component({
  selector: 'app-work-item-list',
  templateUrl: './workitem-list.component.html',
  styleUrls: ['./workitem-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkItemListComponent implements OnInit {
  public isLensEnabled: boolean;
  public isFacebookEnabled: boolean;
  public isAsyncMessageEnabled: boolean;
  public isSmsEnabled: boolean;
  public isChatEnabled: boolean;
  public isEmailEnabled: boolean;
  public isDiscussionsEnabled: boolean;
  public readonly gcUserPermission = GenesysUserPermission;
  public isHybrid = this.commonAuth.isHybrid();

  constructor(private _config: BcConfigService,
              private userPermissionService: UserPermissionService,
              private browserSupportService: BrowserSupportService,
              private serviceEvaluator: ServiceEvaluatorService,
              private discussionsService: DiscussionsService,
              private _bcSettingsService: BcSettingsService,
              private commonAuth: CommonAuthService) {
  }

  async ngOnInit() {
    this.isLensEnabled = await this.commonAuth.isBoldEnabled() && this.userPermissionService.hasPermissionFor(ActionPermissionType.LENS_ENABLED) && this.browserSupportService.isCmsLibSupportedByCurrentBrowser();
    this.isChatEnabled = await this._isServiceTypeEnabled(bcEnums.services.CHATS);
    this.isEmailEnabled = await this._isServiceTypeEnabled(bcEnums.services.EMAILS);
    this.isSmsEnabled = this._config.current.features.smsMessages && await this._isServiceTypeEnabled(bcEnums.services.SMS);
    this.isFacebookEnabled = await this._isServiceTypeEnabled(bcEnums.services.FACEBOOK);
    this.isAsyncMessageEnabled = await this._isServiceTypeEnabled(bcEnums.services.ASYNC_MESSAGE);
    this.isDiscussionsEnabled = await this.commonAuth.isBoldEnabled() && await this._hasDiscussionsFeature();
  }

  private async _isServiceTypeEnabled(serviceType) {
    return await this.commonAuth.isBoldEnabled() && this.serviceEvaluator.isServiceEnabled(serviceType) && this.serviceEvaluator.hasAccessForService(serviceType);
  }

  private async _hasDiscussionsFeature(): Promise<boolean> {
    const settings: Settings = await this._bcSettingsService.getSettings();
    return this._bcSettingsService.ChatFeatures.isEnabled(settings, BcFeatures.LC_DISCUSSIONS) && this._isDiscussionsEnabled() && this._hasDiscussionPermission();
  }

  private _isDiscussionsEnabled(): boolean {
    return this.discussionsService.isDiscussionsEnabled();
  }

  private _hasDiscussionPermission(): boolean {
    return this.discussionsService.hasDiscussionPermission(WorkItemTypes.CHAT) || this.discussionsService.hasDiscussionPermission(WorkItemTypes.EMAIL);
  }
}
